import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import configureStore from './store/configureStore';

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore();
store.dispatch({
    type: 'INIT_APP'
})

createRoot(document.getElementById('root') as any).render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
